import Button from "app/components/UI/Button";
import Link from "app/components/UI/Link";
import PropTypes from "prop-types";
import React from "react";
import StaticPage from "app/components/UI/StaticPage";
import classes from "./Page404.module.css";

export const Page404 = ({ translate, translateHtml }) =>
  <StaticPage>
    <div className={classes.error__code}>
      {translate("Erreur 404")}
    </div>
    <div className={classes.error__message}>
      {translateHtml("La page <br/> que vous cherchez <br/> n'existe pas")}
    </div>
    <Link to="/">
      <Button label={translate("Revenir à la boutique")} fullWidth secondary />
    </Link>
  </StaticPage>;

Page404.propTypes = {
  translate: PropTypes.func.isRequired,
  translateHtml: PropTypes.func.isRequired
};

export default Page404;



// WEBPACK FOOTER //
// ./src/app/components/Page404/Page404.js